import { Form, Select } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import DashboardStore from "../stores/DashboardStore";
import WidgetConstructorStore from "src/modules/administration/stores/WidgetConstructorStore";
import AppModal from "../../common/components/AppModal";

type Props = {
    store: DashboardStore;
    widgetStore: WidgetConstructorStore;
    isVisible: boolean;
    closeDialog: () => void;
};

const AddWidgetDialog: React.FC<Props> = ({
    closeDialog,
    store,
    isVisible,
    widgetStore,
}) => {
    const [form] = Form.useForm();
    const handleSubmit = () => {
        form.validateFields().then(async (vals) => {
            store.activateWidget(vals.id);
            handleClose();
        });
    };

    const handleClose = () => {
        form.resetFields();
        closeDialog();
    };

    const getWidgetOptions = () => {
        const options = [
            {
                label: "Regular widgets",
                options: widgetStore.widgets
                    .map((w) => ({ label: w.name, value: w.id }))
                    .sort((a, b) => a.label.localeCompare(b.label)),
            },

            {
                label: "Grouped widgets",
                options: widgetStore.groupedWidgets.map((w) => ({
                    label: w.name,
                    value: w.id,
                })),
            },
        ];
        return options;
    };
    return (
        <AppModal
            title="Add widget"
            open={isVisible}
            className="alpha-modal comment-in-modal"
            closable={false}
            cancelButtonTitle="Cancel"
            onCancelClick={handleClose}
            cancelButtonProps={{
                "data-id": "query-cancel-button",
                size: undefined,
            }}
            submitButtonTitle="Add"
            submitButtonProps={{
                form: "add-wiget-modal-form",
                size: undefined,
            }}
        >
            <Form
                form={form}
                onFinish={handleSubmit}
                className="alpha-form"
                layout="vertical"
                id="add-wiget-modal-form"
            >
                <Form.Item
                    colon={false}
                    className="dialog-field"
                    label={<span className="dialog-field-label">Widget</span>}
                    name="id"
                    rules={[{ required: true, message: "Widget is required" }]}
                >
                    <Select
                        optionFilterProp="label"
                        showSearch
                        options={getWidgetOptions()}
                    />
                </Form.Item>
            </Form>
        </AppModal>
    );
};
export default observer(AddWidgetDialog);
